import dayjs from 'dayjs';
import localeId from 'dayjs/locale/id';

dayjs.locale(localeId);

/*
  Read: https://day.js.org/docs/en/display/format
  to learn more about dayjs date format options
*/

/**
 * Parse date as native JS Date object
 * https://day.js.org/docs/en/display/as-javascript-date
 * @param {string} date The date string you need to parse
 * @return {Date} The date in native JS Date object
 */
export const toJSDate = (date) => dayjs(date).toDate();

// Current Date without format. Example: 2022-06-20T15:32:28+07:00
export const toCurrentDate = () => dayjs();

/**
 * The name of the day of the week. Example: Senin / Selasa / ... Minggu
 * @param {string} date The date string you need to format
 * @return {string} The formatted date string
 */
export const toDayString = (date) => dayjs(date).format('dddd');

/**
 * Custom date format. Example: 20 Des 2021
 * @param {string} date The date string you need to format
 * @return {string} The formatted date string
 */
export const toDateString = (date) => dayjs(date).format('DD MMM YYYY');

/**
 * Custom date format. Example: 2021-06-25
 * @param {string} date The date string you need to format
 * @return {string} The formatted date string
 */
export const toDateStringNumber = (date) => dayjs(date).format('YYYY-MM-DD');

/**
 * Four-digit year. Example: 2021
 * @param {string} date The date string you need to format
 * @return {string} The formatted date string
 */
export const toYearStringNumber = (date) => dayjs(date).format('YYYY');

/**
 * The month, 2-digits. Example: 01 / 02 / 03 ... 12
 * @param {string} date The date string you need to format
 * @return {string} The formatted date string
 */
export const toMonthStringNumber = (date) => dayjs(date).format('MM');

/**
 * Hour, 2-digits + Minute, 2-digits. Example: 23:59
 * @param {string} date The date string you need to format
 * @return {string} The formatted date string
 */
export const toHourMinute = (date) => dayjs(date).format('HH:mm');

/**
 * Hour, 2-digits + Minute, 2-digits + Second, 2-digits. Example: 23:59:05
 * @param {string} date The date string you need to format
 * @return {string} The formatted date string
 */
export const toHourMinuteSecond = (date) => dayjs(date).format('HH:mm:ss');

/**
 * Format date string to human readable format
 * reference: https://day.js.org/docs/en/display/format
 * @param {string} date The date string you need to format
 * @param {string} dateFormat The standart date format
 * @return {string}  The formatted date string
 */
export const formatDate = (date = new Date(), dateFormat = 'D MMM YYYY') => dayjs(date).format(dateFormat);
